import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: 'NFT Gallery NFT by @bitcoinski'
	}
});

export default app;